import styled from '@emotion/styled'

import { getCSSObjectFromStyleProps } from '../styleProps/StylePropsService'

export const FlexBox = styled.div(
  {
    boxSizing: 'border-box',
    display: 'flex',
  },
  getCSSObjectFromStyleProps,
)
